import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/charge/success.png'


const _hoisted_1 = { class: "wrapper container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "success-img"
  })
], -1)
const _hoisted_3 = { class: "charge-info" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 支付成功 ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "time" }, " 2022-03-04 12:34:56 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Statement = _resolveComponent("Statement")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", {
        class: "nav",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.replaceCharge && _ctx.replaceCharge(...args)))
      }, " 返回充值页面 ")
    ]),
    _createVNode(_component_Statement, { class: "statement" })
  ]))
}